exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footBtn[data-v-3bdcfbf3]{position:absolute;width:100%;bottom:0}.page[data-v-3bdcfbf3]{text-align:left}", ""]);

// exports
